import { render, staticRenderFns } from "./d90index.vue?vue&type=template&id=6b2035d2&scoped=true&"
import script from "./d90index.vue?vue&type=script&lang=js&"
export * from "./d90index.vue?vue&type=script&lang=js&"
import style0 from "./d90index.vue?vue&type=style&index=0&lang=less&"
import style1 from "./d90index.vue?vue&type=style&index=1&id=6b2035d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2035d2",
  null
  
)

export default component.exports